import css from "styled-jsx/css";
import getColor, { COLOR_DICTIONARY } from "@gc-npm/utils.enums.colors";

export default css`
  .outer-wrapper {
    max-width: 100vw;
    overflow-x: scroll;
    position: relative;
    scrollbar-color: #d5ac68 #f1db9d;
    scrollbar-width: thin;
    -ms-overflow-style: none;
  }

  .outer-wrapper::-webkit-scrollbar {
    height: 5px;
  }

  .outer-wrapper::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0);
  }

  .outer-wrapper::-webkit-scrollbar-thumb {
    height: 5px;
    background-color: transparent;
  }

  .outer-wrapper::-webkit-scrollbar-thumb:hover {
    background-color: transparent;
  }

  .outer-wrapper::-webkit-scrollbar:vertical {
    display: none;
  }

  .inner-wrapper {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 0.3rem;
    overflow-x:auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .ButtonContainer {
    float: left;
    :global(.close-icon) {
      flex-shrink: 0;
    }
    .searcher-query {
      :global(.text) {
        max-width: 200px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    :global(.close-icon) {
      flex-shrink: 0;
    }
  }

  .ButtonContainer button {
    padding: 4px 10px;
    border: 1px solid ${getColor(COLOR_DICTIONARY.GREY_400)};
    border-radius: 24px; 
    display: flex;
    width: max-content;
    max-width:100%
  }

  :global(.ButtonContainer button .text) {
    text-transform: inherit;
  }

  .ButtonContainer button.ButtonChecked {
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${getColor(COLOR_DICTIONARY.BLUE_200)} 0% 0% no-repeat padding-box !important;
    border-radius: 24px; 
    border: 1.6px solid ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};
    max-width: 200px;
    :global(.text) {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
  }

  .ButtonContainer button:not(.ButtonChecked):hover {
    background: ${getColor(COLOR_DICTIONARY.GREY1)} 0% 0% no-repeat padding-box !important;
    border-radius: 24px; 
    border: 1px solid ${getColor(COLOR_DICTIONARY.GREY_400)};
    :global(.text) {
        color: ${getColor(COLOR_DICTIONARY.GREY_700)} !important;
        filter: brightness(2) !important; 
    }
  }

  .ButtonContainer button:focus {
    outline: none;
    background: #e6f5fd 0% 0% no-repeat padding-box;
    border-radius: 24px; 
    border: 1.6px solid ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};
  }

  .ButtonContainer button:focus-visible {
    outline: 2px solid ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};
    outline-offset: 2px;
  }

  :global(.ButtonChecked > .text) {
    margin-right: 10px;
  }

  .clear-filters-mobile {
    display: none;
  }

  @media (max-width: 1067px) {
    .inner-wrapper {
      flex-direction: row;
    }

    .clear-filters-mobile {
      display: flex;
      align-items: center;
      flex-shrink: 0;
    }
    .ButtonContainer button {
      padding: 5px 12px;
      border: 1px solid ${getColor(COLOR_DICTIONARY.GREY_400)};
      border-radius: 24px; 
      display: flex;
      width: max-content;
      max-width:100%
    }
  }
`;
